import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';
import { useLocation } from 'react-router-dom';

import RightArrow from '../../Icons/icons/RightArrow';
import AvatarComponent from '../AvatarComponent/AvatarComponent';
import { getSocialCampaignDetailRoute } from '@/config/baseRoutes';

const PostTrackingNotification = ({ notification, setShowNotificationDropdown, markSingleNotificationAsSeen }) => {
  const location = useLocation();

  const handleNavigate = () => {
    const redirectUrl = getSocialCampaignDetailRoute(notification?.content?.campaignId);
    // Normalize URLs by removing trailing slashes for comparison
    const normalizedRedirectUrl = redirectUrl.replace(/\/$/, '');
    const normalizedPathname = location.pathname.replace(/\/$/, '');

    if (normalizedRedirectUrl === normalizedPathname) {
      window.location.reload();
      setShowNotificationDropdown(null);
    } else {
      window.location.href = redirectUrl;
    }
    markSingleNotificationAsSeen();
  };

  return (
    <div className={`post-tracking-notification-container ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent
          src={notification?.content?.profileImg}
          alt={notification?.content?.fullName || notification?.content?.userName}
        />
      </div>
      <div className="right-container">
        <div className="title">{notification?.title}</div>
        <div onClick={() => handleNavigate()} className="post-tracking-notification-container-check-button">
          <span>Check it Out</span> <RightArrow />
        </div>
        <p className="timestamp">{timeAgo(notification?.createdAt)}</p>
      </div>
    </div>
  );
};

export default PostTrackingNotification;
